import { t } from '@/shared/lib/i18n'

/**
 * Display name of a supply (lot) inside a sentence that is not already followed by a noun.
 * Supplies are often named "<Something> Supply"; appending "Supply" again produced
 * "Smoke Supply Supply". The noun is only added when the name does not already end with it.
 */
export function supplyDisplayName(name: string | null | undefined): string {
  const noun = t('instruments.taskLogs.lot')
  const trimmed = name?.trim() ?? ''
  if (!trimmed) return noun
  // Whole-word, case-insensitive match on the trailing noun ("Supplyco Reagent" still gets it).
  const words = trimmed.split(/\s+/)
  return words[words.length - 1].toLowerCase() === noun.toLowerCase()
    ? trimmed
    : `${trimmed} ${noun}`
}
